import type { DirectoryPersonRow } from "../api/chat.types";

/**
 * The seam between the directory's people and the chat's person rows.
 *
 * WHAT IS LEFT, AND WHY THE REST WENT (17 September 2026). This module used to translate people
 * into the kit's `Combobox` options and back — four helpers: one person to an option, a pool of
 * results plus picks, the pool as options, ids back to people — for a «Yeni sohbet» dialog built
 * on `Combobox`/`MultiCombobox`. That dialog was
 * replaced by `NewConversationPane`, a row list, and nothing in the application called those four
 * any more — only their own tests did, which kept them looking alive. Dead helpers that carry a
 * rule ("the reader is never offered", from before a conversation with oneself was allowed) are
 * worse than none: the next picker copies the rule from them.
 */

/**
 * The second line of a person row.
 *
 * Title first, unit second, nothing third. Two people called "Mehmet Örnek" are told apart by
 * what they do far more reliably than by where they sit, and a row that falls back to "—" spends
 * a line saying nothing.
 */
export function personSubtitle(person: DirectoryPersonRow): string | undefined {
  return person.jobTitle ?? person.orgUnit?.name ?? undefined;
}
